/**
 * Translations for Tair App
 * Supports: Arabic (ar), English (en), French (fr), Turkish (tr), Urdu (ur), Hindi (hi)
 */

export const translations = {
  ar: {
    // App
    appName: 'طير',
    loading: 'جاري التحميل...',
    
    // Auth
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    logout: 'تسجيل الخروج',
    loginWithGoogle: 'تسجيل الدخول بواسطة Google',
    loginWithApple: 'تسجيل الدخول بواسطة Apple',
    loginWithEmail: 'تسجيل بالبريد الإلكتروني',
    guestMode: 'دخول كزائر',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    name: 'الاسم',
    or: 'أو',
    haveAccount: 'لديك حساب؟ سجّل الدخول',
    noAccount: 'ليس لديك حساب؟ سجّل الآن',
    termsText: 'بتسجيل الدخول، أنت توافق على',
    termsLink: 'الشروط والأحكام',
    and: 'و',
    privacyLink: 'سياسة الخصوصية',
    watchAdsEarnPoints: 'شاهد الإعلانات واكسب النقاط',
    welcome: 'مرحباً',
    
    // Navigation
    home: 'الرئيسية',
    profile: 'حسابي',
    advertiser: 'أضف إعلانك',
    advertiseNow: 'أعلن',
    notifications: 'الإشعارات',
    withdraw: 'سحب الرصيد',
    watch: 'شاهد',
    games: 'الألعاب',
    
    // Home Page Features
    saqrFortunes: 'ثروات طير',
    saqrFortunesDesc: 'جواهر طير داخل المنصة',
    globalChat: 'الدردشة العامة',
    globalChatDesc: 'تواصل مع لاعبين من حول العالم!',
    friends: 'الأصدقاء',
    friendsDesc: 'أضف أصدقاء وتنافس معهم',
    currentBalance: 'الرصيد الحالي',
    dailyChallenge: 'تحدي اليوم',
    dailyChallengeDesc: 'أكمل التحدي واربح مكافآت إضافية',
    start: 'ابدأ',
    new: 'جديد',
    
    // Home/Ads
    yourPoints: 'نقاطك',
    earnedPoint: 'حصلت على نقطة!',
    loginToEarnPoints: 'سجّل الدخول لكسب النقاط',
    noAds: 'لا توجد إعلانات حالياً',
    refresh: 'تحديث',
    loadingAds: 'جاري تحميل الإعلانات...',
    startWatching: 'ابدأ المشاهدة الآن',
    earnPerAd: 'اكسب 5 نقاط لكل إعلان',
    
    // Profile
    currentPoints: 'نقاطك الحالية',
    dollarValue: 'القيمة بالدولار',
    pointsForWithdraw: 'نقطة للسحب',
    withdrawBalance: 'سحب الرصيد',
    yourStats: 'إحصائياتك',
    totalEarned: 'إجمالي النقاط المكتسبة',
    watchedAds: 'الإعلانات المشاهدة',
    withdrawHistory: 'سجل السحوبات',
    settings: 'الإعدادات',
    helpSupport: 'المساعدة والدعم',
    termsConditions: 'الشروط والأحكام',
    guestModeLabel: 'وضع الزائر',
    backToLogin: 'العودة لتسجيل الدخول',
    version: 'الإصدار',
    changePassword: 'تغيير كلمة المرور',
    transactionHistory: 'سجل المعاملات',
    shareApp: 'شارك التطبيق',
    privacyPolicy: 'سياسة الخصوصية',
    referralCode: 'كود الإحالة',
    copyCode: 'انسخ الكود',
    codeCopied: 'تم نسخ الكود',
    
    // 2FA
    twoFactorAuth: 'التحقق بخطوتين',
    enable2FA: 'تفعيل التحقق بخطوتين',
    disable2FA: 'إلغاء التحقق بخطوتين',
    verificationCode: 'رمز التحقق',
    enterCode: 'أدخل الرمز المرسل',
    codeExpires: 'ينتهي الرمز خلال',
    backupCodes: 'رموز الاسترداد',
    saveBackupCodes: 'احفظ هذه الرموز في مكان آمن',
    
    // Support Tickets
    supportTickets: 'تذاكر الدعم',
    createTicket: 'إنشاء تذكرة',
    myTickets: 'تذاكري',
    ticketSubject: 'موضوع التذكرة',
    ticketMessage: 'رسالتك',
    ticketCategory: 'التصنيف',
    categoryGeneral: 'استفسار عام',
    categoryTechnical: 'مشكلة تقنية',
    categoryPayment: 'الدفع والسحب',
    categoryAccount: 'حسابي',
    ticketStatus: 'حالة التذكرة',
    statusOpen: 'مفتوحة',
    statusInProgress: 'قيد المعالجة',
    statusResolved: 'تم الحل',
    statusClosed: 'مغلقة',
    replyToTicket: 'الرد على التذكرة',
    closeTicket: 'إغلاق التذكرة',
    
    // Comments
    comments: 'التعليقات',
    addComment: 'أضف تعليق',
    writeComment: 'اكتب تعليقك...',
    reply: 'رد',
    like: 'إعجاب',
    noComments: 'لا توجد تعليقات بعد',
    deleteComment: 'حذف التعليق',
    
    // Dark Mode
    darkMode: 'الوضع الداكن',
    lightMode: 'الوضع الفاتح',
    systemMode: 'حسب النظام',
    appearance: 'المظهر',
    
    // Language
    language: 'اللغة',
    arabic: 'العربية',
    english: 'English',
    french: 'Français',
    turkish: 'Türkçe',
    urdu: 'اردو',
    hindi: 'हिन्दी',
    
    // Withdraw
    withdrawTitle: 'سحب الرصيد',
    availablePoints: 'النقاط المتاحة',
    selectMethod: 'اختر طريقة السحب',
    accountDetails: 'تفاصيل الحساب',
    bankTransfer: 'تحويل بنكي',
    bankName: 'اسم البنك',
    accountNumber: 'رقم الحساب',
    ibanNumber: 'رقم IBAN',
    phoneNumber: 'رقم الجوال',
    submitRequest: 'إرسال طلب السحب',
    withdrawNotice: 'يتم مراجعة طلبات السحب خلال 24-48 ساعة',
    insufficientPoints: 'نقاط غير كافية',
    needMinPoints: 'تحتاج 500 نقطة على الأقل للسحب',
    
    // Advertiser
    addYourAd: 'أضف إعلانك',
    reachUsers: 'وصّل إعلانك لآلاف المستخدمين',
    selectPackage: 'اختر باقتك',
    adDetails: 'تفاصيل الإعلان',
    advertiserName: 'اسم المعلن',
    adTitle: 'عنوان الإعلان',
    adDescription: 'وصف الإعلان',
    videoUrl: 'رابط الفيديو',
    thumbnailUrl: 'رابط الصورة المصغرة',
    totalAmount: 'المبلغ الإجمالي',
    continueToPayment: 'متابعة للدفع',
    selectPaymentMethod: 'اختر طريقة الدفع',
    amountRequired: 'المبلغ المطلوب',
    payNow: 'ادفع الآن',
    
    // Payment
    paymentSuccess: 'تم الدفع بنجاح!',
    paymentSuccessMsg: 'سيتم مراجعة إعلانك وتفعيله قريباً',
    paymentCancelled: 'تم إلغاء الدفع',
    paymentCancelledMsg: 'تم إلغاء عملية الدفع',
    retry: 'إعادة المحاولة',
    backToHome: 'العودة للرئيسية',
    
    // Success/Error messages
    success: 'تم بنجاح!',
    error: 'خطأ',
    fillAllFields: 'أكمل جميع الحقول المطلوبة',
    
    // Misc
    back: 'رجوع',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    save: 'حفظ',
    delete: 'حذف',
    edit: 'تعديل',
    send: 'إرسال',
    close: 'إغلاق',
    points: 'النقاط',
    today: 'اليوم',
    available: 'المتاح',
    remaining: 'المتبقي',
    earnRate: 'معدل الكسب',
    totalPoints: 'إجمالي النقاط',
    currentBalance: 'الرصيد الحالي',
  },
  
  en: {
    appName: 'Tair',
    loading: 'Loading...',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    loginWithGoogle: 'Login with Google',
    loginWithApple: 'Login with Apple',
    loginWithEmail: 'Login with Email',
    guestMode: 'Continue as guest',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    or: 'or',
    haveAccount: 'Have an account? Login',
    noAccount: "Don't have an account? Register",
    termsText: 'By logging in, you agree to',
    termsLink: 'Terms & Conditions',
    and: 'and',
    privacyLink: 'Privacy Policy',
    watchAdsEarnPoints: 'Watch ads and earn points',
    welcome: 'Welcome',
    home: 'Home',
    profile: 'Profile',
    advertiser: 'Add Your Ad',
    advertiseNow: 'Advertise',
    notifications: 'Notifications',
    withdraw: 'Withdraw',
    watch: 'Watch',
    games: 'Games',
    
    // Home Page Features
    saqrFortunes: 'Tair Fortunes',
    saqrFortunesDesc: 'Tair gems inside the platform',
    globalChat: 'Global Chat',
    globalChatDesc: 'Connect with players worldwide!',
    friends: 'Friends',
    friendsDesc: 'Add friends and compete with them',
    currentBalance: 'Current Balance',
    dailyChallenge: 'Daily Challenge',
    dailyChallengeDesc: 'Complete the challenge and earn extra rewards',
    start: 'Start',
    new: 'New',
    
    yourPoints: 'Your Points',
    earnedPoint: 'Earned a point!',
    loginToEarnPoints: 'Login to earn points',
    noAds: 'No ads available',
    refresh: 'Refresh',
    loadingAds: 'Loading ads...',
    startWatching: 'Start Watching Now',
    earnPerAd: 'Earn 5 points per ad',
    currentPoints: 'Current Points',
    dollarValue: 'Dollar Value',
    pointsForWithdraw: 'points to withdraw',
    withdrawBalance: 'Withdraw Balance',
    yourStats: 'Your Stats',
    totalEarned: 'Total Points Earned',
    watchedAds: 'Watched Ads',
    withdrawHistory: 'Withdrawal History',
    settings: 'Settings',
    helpSupport: 'Help & Support',
    termsConditions: 'Terms & Conditions',
    guestModeLabel: 'Guest Mode',
    backToLogin: 'Back to Login',
    version: 'Version',
    changePassword: 'Change Password',
    transactionHistory: 'Transaction History',
    shareApp: 'Share App',
    privacyPolicy: 'Privacy Policy',
    referralCode: 'Referral Code',
    copyCode: 'Copy Code',
    codeCopied: 'Code Copied',
    twoFactorAuth: 'Two-Factor Authentication',
    enable2FA: 'Enable 2FA',
    disable2FA: 'Disable 2FA',
    verificationCode: 'Verification Code',
    enterCode: 'Enter the code sent',
    codeExpires: 'Code expires in',
    backupCodes: 'Backup Codes',
    saveBackupCodes: 'Save these codes in a safe place',
    supportTickets: 'Support Tickets',
    createTicket: 'Create Ticket',
    myTickets: 'My Tickets',
    ticketSubject: 'Subject',
    ticketMessage: 'Your Message',
    ticketCategory: 'Category',
    categoryGeneral: 'General Inquiry',
    categoryTechnical: 'Technical Issue',
    categoryPayment: 'Payment & Withdrawal',
    categoryAccount: 'My Account',
    ticketStatus: 'Status',
    statusOpen: 'Open',
    statusInProgress: 'In Progress',
    statusResolved: 'Resolved',
    statusClosed: 'Closed',
    replyToTicket: 'Reply',
    closeTicket: 'Close Ticket',
    comments: 'Comments',
    addComment: 'Add Comment',
    writeComment: 'Write your comment...',
    reply: 'Reply',
    like: 'Like',
    noComments: 'No comments yet',
    deleteComment: 'Delete Comment',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    systemMode: 'System Default',
    appearance: 'Appearance',
    language: 'Language',
    arabic: 'العربية',
    english: 'English',
    french: 'Français',
    turkish: 'Türkçe',
    urdu: 'اردو',
    hindi: 'हिन्दी',
    withdrawTitle: 'Withdraw Balance',
    availablePoints: 'Available Points',
    selectMethod: 'Select Withdrawal Method',
    accountDetails: 'Account Details',
    bankTransfer: 'Bank Transfer',
    bankName: 'Bank Name',
    accountNumber: 'Account Number',
    ibanNumber: 'IBAN Number',
    phoneNumber: 'Phone Number',
    submitRequest: 'Submit Withdrawal Request',
    withdrawNotice: 'Withdrawal requests are reviewed within 24-48 hours',
    insufficientPoints: 'Insufficient Points',
    needMinPoints: 'You need at least 500 points to withdraw',
    addYourAd: 'Add Your Ad',
    reachUsers: 'Reach thousands of users',
    selectPackage: 'Select Package',
    adDetails: 'Ad Details',
    advertiserName: 'Advertiser Name',
    adTitle: 'Ad Title',
    adDescription: 'Ad Description',
    videoUrl: 'Video URL',
    thumbnailUrl: 'Thumbnail URL',
    totalAmount: 'Total Amount',
    continueToPayment: 'Continue to Payment',
    selectPaymentMethod: 'Select Payment Method',
    amountRequired: 'Amount Required',
    payNow: 'Pay Now',
    paymentSuccess: 'Payment Successful!',
    paymentSuccessMsg: 'Your ad will be reviewed and activated soon',
    paymentCancelled: 'Payment Cancelled',
    paymentCancelledMsg: 'Payment was cancelled',
    retry: 'Retry',
    backToHome: 'Back to Home',
    success: 'Success!',
    error: 'Error',
    fillAllFields: 'Please fill all required fields',
    back: 'Back',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    send: 'Send',
    close: 'Close',
    points: 'Points',
    today: 'Today',
    available: 'Available',
    remaining: 'Remaining',
    earnRate: 'Earn Rate',
    totalPoints: 'Total Points',
    currentBalance: 'Current Balance',
  },
  
  fr: {
    appName: 'Tair',
    loading: 'Chargement...',
    login: 'Connexion',
    register: "S'inscrire",
    logout: 'Déconnexion',
    loginWithGoogle: 'Connexion avec Google',
    loginWithApple: 'Connexion avec Apple',
    loginWithEmail: 'Connexion par email',
    guestMode: 'Continuer en tant qu\'invité',
    email: 'Email',
    password: 'Mot de passe',
    name: 'Nom',
    or: 'ou',
    haveAccount: 'Vous avez un compte? Connectez-vous',
    noAccount: "Pas de compte? Inscrivez-vous",
    termsText: 'En vous connectant, vous acceptez',
    termsLink: 'Conditions d\'utilisation',
    and: 'et',
    privacyLink: 'Politique de confidentialité',
    watchAdsEarnPoints: 'Regardez des pubs et gagnez des points',
    welcome: 'Bienvenue',
    home: 'Accueil',
    profile: 'Profil',
    advertiser: 'Ajouter une annonce',
    advertiseNow: 'Publicité',
    notifications: 'Notifications',
    withdraw: 'Retrait',
    watch: 'Regarder',
    yourPoints: 'Vos points',
    earnedPoint: 'Point gagné!',
    loginToEarnPoints: 'Connectez-vous pour gagner des points',
    noAds: 'Aucune publicité disponible',
    refresh: 'Actualiser',
    loadingAds: 'Chargement des publicités...',
    startWatching: 'Commencer à regarder',
    earnPerAd: 'Gagnez 5 points par pub',
    currentPoints: 'Points actuels',
    dollarValue: 'Valeur en dollars',
    pointsForWithdraw: 'points pour retirer',
    withdrawBalance: 'Retirer le solde',
    yourStats: 'Vos statistiques',
    totalEarned: 'Total des points gagnés',
    watchedAds: 'Publicités regardées',
    withdrawHistory: 'Historique des retraits',
    settings: 'Paramètres',
    helpSupport: 'Aide et support',
    termsConditions: 'Conditions générales',
    guestModeLabel: 'Mode invité',
    backToLogin: 'Retour à la connexion',
    version: 'Version',
    changePassword: 'Changer le mot de passe',
    transactionHistory: 'Historique des transactions',
    shareApp: 'Partager l\'application',
    privacyPolicy: 'Politique de confidentialité',
    referralCode: 'Code de parrainage',
    copyCode: 'Copier le code',
    codeCopied: 'Code copié',
    twoFactorAuth: 'Authentification à deux facteurs',
    enable2FA: 'Activer 2FA',
    disable2FA: 'Désactiver 2FA',
    verificationCode: 'Code de vérification',
    enterCode: 'Entrez le code envoyé',
    codeExpires: 'Le code expire dans',
    backupCodes: 'Codes de secours',
    saveBackupCodes: 'Sauvegardez ces codes en lieu sûr',
    supportTickets: 'Tickets de support',
    createTicket: 'Créer un ticket',
    myTickets: 'Mes tickets',
    ticketSubject: 'Sujet',
    ticketMessage: 'Votre message',
    ticketCategory: 'Catégorie',
    categoryGeneral: 'Question générale',
    categoryTechnical: 'Problème technique',
    categoryPayment: 'Paiement et retrait',
    categoryAccount: 'Mon compte',
    ticketStatus: 'Statut',
    statusOpen: 'Ouvert',
    statusInProgress: 'En cours',
    statusResolved: 'Résolu',
    statusClosed: 'Fermé',
    replyToTicket: 'Répondre',
    closeTicket: 'Fermer le ticket',
    comments: 'Commentaires',
    addComment: 'Ajouter un commentaire',
    writeComment: 'Écrivez votre commentaire...',
    reply: 'Répondre',
    like: 'J\'aime',
    noComments: 'Pas encore de commentaires',
    deleteComment: 'Supprimer le commentaire',
    darkMode: 'Mode sombre',
    lightMode: 'Mode clair',
    systemMode: 'Défaut système',
    appearance: 'Apparence',
    language: 'Langue',
    arabic: 'العربية',
    english: 'English',
    french: 'Français',
    turkish: 'Türkçe',
    urdu: 'اردو',
    hindi: 'हिन्दी',
    withdrawTitle: 'Retirer le solde',
    availablePoints: 'Points disponibles',
    selectMethod: 'Sélectionner la méthode de retrait',
    accountDetails: 'Détails du compte',
    bankTransfer: 'Virement bancaire',
    bankName: 'Nom de la banque',
    accountNumber: 'Numéro de compte',
    ibanNumber: 'Numéro IBAN',
    phoneNumber: 'Numéro de téléphone',
    submitRequest: 'Soumettre la demande de retrait',
    withdrawNotice: 'Les demandes de retrait sont examinées sous 24-48 heures',
    insufficientPoints: 'Points insuffisants',
    needMinPoints: 'Vous avez besoin d\'au moins 500 points pour retirer',
    addYourAd: 'Ajouter votre annonce',
    reachUsers: 'Atteignez des milliers d\'utilisateurs',
    selectPackage: 'Sélectionner le forfait',
    adDetails: 'Détails de l\'annonce',
    advertiserName: 'Nom de l\'annonceur',
    adTitle: 'Titre de l\'annonce',
    adDescription: 'Description de l\'annonce',
    videoUrl: 'URL de la vidéo',
    thumbnailUrl: 'URL de la miniature',
    totalAmount: 'Montant total',
    continueToPayment: 'Continuer vers le paiement',
    selectPaymentMethod: 'Sélectionner le mode de paiement',
    amountRequired: 'Montant requis',
    payNow: 'Payer maintenant',
    paymentSuccess: 'Paiement réussi!',
    paymentSuccessMsg: 'Votre annonce sera examinée et activée bientôt',
    paymentCancelled: 'Paiement annulé',
    paymentCancelledMsg: 'Le paiement a été annulé',
    retry: 'Réessayer',
    backToHome: 'Retour à l\'accueil',
    success: 'Succès!',
    error: 'Erreur',
    fillAllFields: 'Veuillez remplir tous les champs requis',
    back: 'Retour',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    send: 'Envoyer',
    close: 'Fermer',
    points: 'Points',
    today: 'Aujourd\'hui',
    available: 'Disponible',
    remaining: 'Restant',
    earnRate: 'Taux de gain',
    totalPoints: 'Total des points',
    currentBalance: 'Solde actuel',
  },
  
  tr: {
    appName: 'Tair',
    loading: 'Yükleniyor...',
    login: 'Giriş Yap',
    register: 'Kayıt Ol',
    logout: 'Çıkış Yap',
    loginWithGoogle: 'Google ile Giriş',
    loginWithApple: 'Apple ile Giriş',
    loginWithEmail: 'Email ile Giriş',
    guestMode: 'Misafir olarak devam et',
    email: 'E-posta',
    password: 'Şifre',
    name: 'İsim',
    or: 'veya',
    haveAccount: 'Hesabınız var mı? Giriş yapın',
    noAccount: 'Hesabınız yok mu? Kayıt olun',
    termsText: 'Giriş yaparak kabul etmiş olursunuz',
    termsLink: 'Kullanım Şartları',
    and: 've',
    privacyLink: 'Gizlilik Politikası',
    watchAdsEarnPoints: 'Reklam izle ve puan kazan',
    welcome: 'Hoş geldiniz',
    home: 'Ana Sayfa',
    profile: 'Profil',
    advertiser: 'Reklam Ekle',
    advertiseNow: 'Reklam Ver',
    notifications: 'Bildirimler',
    withdraw: 'Para Çek',
    watch: 'İzle',
    yourPoints: 'Puanlarınız',
    earnedPoint: 'Puan kazandınız!',
    loginToEarnPoints: 'Puan kazanmak için giriş yapın',
    noAds: 'Reklam yok',
    refresh: 'Yenile',
    loadingAds: 'Reklamlar yükleniyor...',
    startWatching: 'İzlemeye Başla',
    earnPerAd: 'Her reklam için 5 puan kazan',
    currentPoints: 'Mevcut Puanlar',
    dollarValue: 'Dolar Değeri',
    pointsForWithdraw: 'çekim için puan',
    withdrawBalance: 'Bakiye Çek',
    yourStats: 'İstatistikleriniz',
    totalEarned: 'Toplam Kazanılan Puan',
    watchedAds: 'İzlenen Reklamlar',
    withdrawHistory: 'Çekim Geçmişi',
    settings: 'Ayarlar',
    helpSupport: 'Yardım ve Destek',
    termsConditions: 'Şartlar ve Koşullar',
    guestModeLabel: 'Misafir Modu',
    backToLogin: 'Girişe Dön',
    version: 'Sürüm',
    changePassword: 'Şifre Değiştir',
    transactionHistory: 'İşlem Geçmişi',
    shareApp: 'Uygulamayı Paylaş',
    privacyPolicy: 'Gizlilik Politikası',
    referralCode: 'Referans Kodu',
    copyCode: 'Kodu Kopyala',
    codeCopied: 'Kod Kopyalandı',
    twoFactorAuth: 'İki Faktörlü Doğrulama',
    enable2FA: '2FA Etkinleştir',
    disable2FA: '2FA Devre Dışı Bırak',
    verificationCode: 'Doğrulama Kodu',
    enterCode: 'Gönderilen kodu girin',
    codeExpires: 'Kod şu sürede sona erer',
    backupCodes: 'Yedek Kodlar',
    saveBackupCodes: 'Bu kodları güvenli bir yere kaydedin',
    supportTickets: 'Destek Talepleri',
    createTicket: 'Talep Oluştur',
    myTickets: 'Taleplerim',
    ticketSubject: 'Konu',
    ticketMessage: 'Mesajınız',
    ticketCategory: 'Kategori',
    categoryGeneral: 'Genel Soru',
    categoryTechnical: 'Teknik Sorun',
    categoryPayment: 'Ödeme ve Çekim',
    categoryAccount: 'Hesabım',
    ticketStatus: 'Durum',
    statusOpen: 'Açık',
    statusInProgress: 'İşlemde',
    statusResolved: 'Çözüldü',
    statusClosed: 'Kapalı',
    replyToTicket: 'Yanıtla',
    closeTicket: 'Talebi Kapat',
    comments: 'Yorumlar',
    addComment: 'Yorum Ekle',
    writeComment: 'Yorumunuzu yazın...',
    reply: 'Yanıtla',
    like: 'Beğen',
    noComments: 'Henüz yorum yok',
    deleteComment: 'Yorumu Sil',
    darkMode: 'Karanlık Mod',
    lightMode: 'Aydınlık Mod',
    systemMode: 'Sistem Varsayılanı',
    appearance: 'Görünüm',
    language: 'Dil',
    arabic: 'العربية',
    english: 'English',
    french: 'Français',
    turkish: 'Türkçe',
    urdu: 'اردو',
    hindi: 'हिन्दी',
    withdrawTitle: 'Bakiye Çek',
    availablePoints: 'Mevcut Puanlar',
    selectMethod: 'Çekim Yöntemi Seç',
    accountDetails: 'Hesap Detayları',
    bankTransfer: 'Banka Transferi',
    bankName: 'Banka Adı',
    accountNumber: 'Hesap Numarası',
    ibanNumber: 'IBAN Numarası',
    phoneNumber: 'Telefon Numarası',
    submitRequest: 'Çekim Talebi Gönder',
    withdrawNotice: 'Çekim talepleri 24-48 saat içinde incelenir',
    insufficientPoints: 'Yetersiz Puan',
    needMinPoints: 'Çekim için en az 500 puan gerekli',
    addYourAd: 'Reklamını Ekle',
    reachUsers: 'Binlerce kullanıcıya ulaş',
    selectPackage: 'Paket Seç',
    adDetails: 'Reklam Detayları',
    advertiserName: 'Reklamveren Adı',
    adTitle: 'Reklam Başlığı',
    adDescription: 'Reklam Açıklaması',
    videoUrl: 'Video URL',
    thumbnailUrl: 'Küçük Resim URL',
    totalAmount: 'Toplam Tutar',
    continueToPayment: 'Ödemeye Devam',
    selectPaymentMethod: 'Ödeme Yöntemi Seç',
    amountRequired: 'Gerekli Tutar',
    payNow: 'Şimdi Öde',
    paymentSuccess: 'Ödeme Başarılı!',
    paymentSuccessMsg: 'Reklamınız incelenecek ve yakında aktifleştirilecek',
    paymentCancelled: 'Ödeme İptal Edildi',
    paymentCancelledMsg: 'Ödeme iptal edildi',
    retry: 'Tekrar Dene',
    backToHome: 'Ana Sayfaya Dön',
    success: 'Başarılı!',
    error: 'Hata',
    fillAllFields: 'Lütfen tüm gerekli alanları doldurun',
    back: 'Geri',
    cancel: 'İptal',
    confirm: 'Onayla',
    save: 'Kaydet',
    delete: 'Sil',
    edit: 'Düzenle',
    send: 'Gönder',
    close: 'Kapat',
    points: 'Puan',
    today: 'Bugün',
    available: 'Mevcut',
    remaining: 'Kalan',
    earnRate: 'Kazanç Oranı',
    totalPoints: 'Toplam Puan',
    currentBalance: 'Mevcut Bakiye',
  },
  
  ur: {
    appName: 'طير',
    loading: 'لوڈ ہو رہا ہے...',
    login: 'لاگ ان',
    register: 'رجسٹر',
    logout: 'لاگ آؤٹ',
    loginWithGoogle: 'گوگل سے لاگ ان',
    loginWithApple: 'ایپل سے لاگ ان',
    loginWithEmail: 'ای میل سے لاگ ان',
    guestMode: 'مہمان کے طور پر جاری رکھیں',
    email: 'ای میل',
    password: 'پاس ورڈ',
    name: 'نام',
    or: 'یا',
    haveAccount: 'اکاؤنٹ ہے؟ لاگ ان کریں',
    noAccount: 'اکاؤنٹ نہیں ہے؟ رجسٹر کریں',
    termsText: 'لاگ ان کرکے، آپ اتفاق کرتے ہیں',
    termsLink: 'شرائط و ضوابط',
    and: 'اور',
    privacyLink: 'رازداری کی پالیسی',
    watchAdsEarnPoints: 'اشتہارات دیکھیں اور پوائنٹس کمائیں',
    welcome: 'خوش آمدید',
    home: 'ہوم',
    profile: 'پروفائل',
    advertiser: 'اشتہار شامل کریں',
    advertiseNow: 'اشتہار دیں',
    notifications: 'اطلاعات',
    withdraw: 'رقم نکالیں',
    watch: 'دیکھیں',
    yourPoints: 'آپ کے پوائنٹس',
    earnedPoint: 'پوائنٹ کمایا!',
    loginToEarnPoints: 'پوائنٹس کمانے کے لیے لاگ ان کریں',
    noAds: 'کوئی اشتہار دستیاب نہیں',
    refresh: 'تازہ کریں',
    loadingAds: 'اشتہارات لوڈ ہو رہے ہیں...',
    startWatching: 'دیکھنا شروع کریں',
    earnPerAd: 'ہر اشتہار پر 5 پوائنٹس کمائیں',
    currentPoints: 'موجودہ پوائنٹس',
    dollarValue: 'ڈالر کی قیمت',
    pointsForWithdraw: 'نکالنے کے لیے پوائنٹس',
    withdrawBalance: 'بیلنس نکالیں',
    yourStats: 'آپ کے اعداد و شمار',
    totalEarned: 'کل کمائے گئے پوائنٹس',
    watchedAds: 'دیکھے گئے اشتہارات',
    withdrawHistory: 'نکلوانے کی تاریخ',
    settings: 'ترتیبات',
    helpSupport: 'مدد اور سپورٹ',
    termsConditions: 'شرائط و ضوابط',
    guestModeLabel: 'مہمان موڈ',
    backToLogin: 'لاگ ان پر واپس',
    version: 'ورژن',
    changePassword: 'پاس ورڈ تبدیل کریں',
    transactionHistory: 'لین دین کی تاریخ',
    shareApp: 'ایپ شیئر کریں',
    privacyPolicy: 'رازداری کی پالیسی',
    referralCode: 'ریفرل کوڈ',
    copyCode: 'کوڈ کاپی کریں',
    codeCopied: 'کوڈ کاپی ہو گیا',
    twoFactorAuth: 'دو مرحلہ تصدیق',
    enable2FA: '2FA فعال کریں',
    disable2FA: '2FA غیر فعال کریں',
    verificationCode: 'تصدیقی کوڈ',
    enterCode: 'بھیجا گیا کوڈ درج کریں',
    codeExpires: 'کوڈ ختم ہو جائے گا',
    backupCodes: 'بیک اپ کوڈز',
    saveBackupCodes: 'یہ کوڈز محفوظ جگہ پر رکھیں',
    supportTickets: 'سپورٹ ٹکٹس',
    createTicket: 'ٹکٹ بنائیں',
    myTickets: 'میری ٹکٹس',
    ticketSubject: 'موضوع',
    ticketMessage: 'آپ کا پیغام',
    ticketCategory: 'زمرہ',
    categoryGeneral: 'عام سوال',
    categoryTechnical: 'تکنیکی مسئلہ',
    categoryPayment: 'ادائیگی اور نکلوانا',
    categoryAccount: 'میرا اکاؤنٹ',
    ticketStatus: 'حیثیت',
    statusOpen: 'کھلا',
    statusInProgress: 'جاری ہے',
    statusResolved: 'حل ہو گیا',
    statusClosed: 'بند',
    replyToTicket: 'جواب دیں',
    closeTicket: 'ٹکٹ بند کریں',
    comments: 'تبصرے',
    addComment: 'تبصرہ شامل کریں',
    writeComment: 'اپنا تبصرہ لکھیں...',
    reply: 'جواب',
    like: 'پسند',
    noComments: 'ابھی کوئی تبصرے نہیں',
    deleteComment: 'تبصرہ حذف کریں',
    darkMode: 'ڈارک موڈ',
    lightMode: 'لائٹ موڈ',
    systemMode: 'سسٹم ڈیفالٹ',
    appearance: 'ظاہری شکل',
    language: 'زبان',
    arabic: 'العربية',
    english: 'English',
    french: 'Français',
    turkish: 'Türkçe',
    urdu: 'اردو',
    hindi: 'हिन्दी',
    withdrawTitle: 'بیلنس نکالیں',
    availablePoints: 'دستیاب پوائنٹس',
    selectMethod: 'نکلوانے کا طریقہ منتخب کریں',
    accountDetails: 'اکاؤنٹ کی تفصیلات',
    bankTransfer: 'بینک ٹرانسفر',
    bankName: 'بینک کا نام',
    accountNumber: 'اکاؤنٹ نمبر',
    ibanNumber: 'IBAN نمبر',
    phoneNumber: 'فون نمبر',
    submitRequest: 'درخواست جمع کرائیں',
    withdrawNotice: 'نکلوانے کی درخواستیں 24-48 گھنٹوں میں جائزہ لی جاتی ہیں',
    insufficientPoints: 'ناکافی پوائنٹس',
    needMinPoints: 'نکلوانے کے لیے کم از کم 500 پوائنٹس درکار ہیں',
    addYourAd: 'اپنا اشتہار شامل کریں',
    reachUsers: 'ہزاروں صارفین تک پہنچیں',
    selectPackage: 'پیکج منتخب کریں',
    adDetails: 'اشتہار کی تفصیلات',
    advertiserName: 'مشتہر کا نام',
    adTitle: 'اشتہار کا عنوان',
    adDescription: 'اشتہار کی تفصیل',
    videoUrl: 'ویڈیو URL',
    thumbnailUrl: 'تھمب نیل URL',
    totalAmount: 'کل رقم',
    continueToPayment: 'ادائیگی جاری رکھیں',
    selectPaymentMethod: 'ادائیگی کا طریقہ منتخب کریں',
    amountRequired: 'مطلوبہ رقم',
    payNow: 'ابھی ادائیگی کریں',
    paymentSuccess: 'ادائیگی کامیاب!',
    paymentSuccessMsg: 'آپ کے اشتہار کا جائزہ لیا جائے گا اور جلد فعال کیا جائے گا',
    paymentCancelled: 'ادائیگی منسوخ',
    paymentCancelledMsg: 'ادائیگی منسوخ کر دی گئی',
    retry: 'دوبارہ کوشش کریں',
    backToHome: 'ہوم پر واپس',
    success: 'کامیاب!',
    error: 'خرابی',
    fillAllFields: 'براہ کرم تمام مطلوبہ فیلڈز پُر کریں',
    back: 'واپس',
    cancel: 'منسوخ',
    confirm: 'تصدیق',
    save: 'محفوظ کریں',
    delete: 'حذف کریں',
    edit: 'ترمیم',
    send: 'بھیجیں',
    close: 'بند کریں',
    points: 'پوائنٹس',
    today: 'آج',
    available: 'دستیاب',
    remaining: 'باقی',
    earnRate: 'کمائی کی شرح',
    totalPoints: 'کل پوائنٹس',
    currentBalance: 'موجودہ بیلنس',
  },
  
  hi: {
    appName: 'Tair',
    loading: 'लोड हो रहा है...',
    login: 'लॉग इन',
    register: 'रजिस्टर',
    logout: 'लॉग आउट',
    loginWithGoogle: 'Google से लॉग इन',
    loginWithApple: 'Apple से लॉग इन',
    loginWithEmail: 'ईमेल से लॉग इन',
    guestMode: 'अतिथि के रूप में जारी रखें',
    email: 'ईमेल',
    password: 'पासवर्ड',
    name: 'नाम',
    or: 'या',
    haveAccount: 'खाता है? लॉग इन करें',
    noAccount: 'खाता नहीं है? रजिस्टर करें',
    termsText: 'लॉग इन करके, आप सहमत हैं',
    termsLink: 'नियम और शर्तें',
    and: 'और',
    privacyLink: 'गोपनीयता नीति',
    watchAdsEarnPoints: 'विज्ञापन देखें और पॉइंट्स कमाएं',
    welcome: 'स्वागत है',
    home: 'होम',
    profile: 'प्रोफाइल',
    advertiser: 'विज्ञापन जोड़ें',
    advertiseNow: 'विज्ञापन दें',
    notifications: 'सूचनाएं',
    withdraw: 'निकासी',
    watch: 'देखें',
    yourPoints: 'आपके पॉइंट्स',
    earnedPoint: 'पॉइंट कमाया!',
    loginToEarnPoints: 'पॉइंट्स कमाने के लिए लॉग इन करें',
    noAds: 'कोई विज्ञापन उपलब्ध नहीं',
    refresh: 'रिफ्रेश',
    loadingAds: 'विज्ञापन लोड हो रहे हैं...',
    startWatching: 'देखना शुरू करें',
    earnPerAd: 'प्रति विज्ञापन 5 पॉइंट्स कमाएं',
    currentPoints: 'वर्तमान पॉइंट्स',
    dollarValue: 'डॉलर मूल्य',
    pointsForWithdraw: 'निकासी के लिए पॉइंट्स',
    withdrawBalance: 'बैलेंस निकालें',
    yourStats: 'आपके आंकड़े',
    totalEarned: 'कुल अर्जित पॉइंट्स',
    watchedAds: 'देखे गए विज्ञापन',
    withdrawHistory: 'निकासी इतिहास',
    settings: 'सेटिंग्स',
    helpSupport: 'सहायता और समर्थन',
    termsConditions: 'नियम और शर्तें',
    guestModeLabel: 'अतिथि मोड',
    backToLogin: 'लॉग इन पर वापस',
    version: 'संस्करण',
    changePassword: 'पासवर्ड बदलें',
    transactionHistory: 'लेन-देन इतिहास',
    shareApp: 'ऐप शेयर करें',
    privacyPolicy: 'गोपनीयता नीति',
    referralCode: 'रेफरल कोड',
    copyCode: 'कोड कॉपी करें',
    codeCopied: 'कोड कॉपी हो गया',
    twoFactorAuth: 'दो-कारक प्रमाणीकरण',
    enable2FA: '2FA सक्षम करें',
    disable2FA: '2FA अक्षम करें',
    verificationCode: 'सत्यापन कोड',
    enterCode: 'भेजा गया कोड दर्ज करें',
    codeExpires: 'कोड समाप्त होगा',
    backupCodes: 'बैकअप कोड',
    saveBackupCodes: 'इन कोड्स को सुरक्षित जगह पर सेव करें',
    supportTickets: 'सपोर्ट टिकट',
    createTicket: 'टिकट बनाएं',
    myTickets: 'मेरी टिकट',
    ticketSubject: 'विषय',
    ticketMessage: 'आपका संदेश',
    ticketCategory: 'श्रेणी',
    categoryGeneral: 'सामान्य प्रश्न',
    categoryTechnical: 'तकनीकी समस्या',
    categoryPayment: 'भुगतान और निकासी',
    categoryAccount: 'मेरा खाता',
    ticketStatus: 'स्थिति',
    statusOpen: 'खुला',
    statusInProgress: 'प्रगति में',
    statusResolved: 'हल हो गया',
    statusClosed: 'बंद',
    replyToTicket: 'जवाब दें',
    closeTicket: 'टिकट बंद करें',
    comments: 'टिप्पणियां',
    addComment: 'टिप्पणी जोड़ें',
    writeComment: 'अपनी टिप्पणी लिखें...',
    reply: 'जवाब',
    like: 'पसंद',
    noComments: 'अभी कोई टिप्पणी नहीं',
    deleteComment: 'टिप्पणी हटाएं',
    darkMode: 'डार्क मोड',
    lightMode: 'लाइट मोड',
    systemMode: 'सिस्टम डिफ़ॉल्ट',
    appearance: 'दिखावट',
    language: 'भाषा',
    arabic: 'العربية',
    english: 'English',
    french: 'Français',
    turkish: 'Türkçe',
    urdu: 'اردو',
    hindi: 'हिन्दी',
    withdrawTitle: 'बैलेंस निकालें',
    availablePoints: 'उपलब्ध पॉइंट्स',
    selectMethod: 'निकासी विधि चुनें',
    accountDetails: 'खाता विवरण',
    bankTransfer: 'बैंक ट्रांसफर',
    bankName: 'बैंक का नाम',
    accountNumber: 'खाता नंबर',
    ibanNumber: 'IBAN नंबर',
    phoneNumber: 'फोन नंबर',
    submitRequest: 'अनुरोध सबमिट करें',
    withdrawNotice: 'निकासी अनुरोधों की 24-48 घंटों में समीक्षा की जाती है',
    insufficientPoints: 'अपर्याप्त पॉइंट्स',
    needMinPoints: 'निकासी के लिए कम से कम 500 पॉइंट्स चाहिए',
    addYourAd: 'अपना विज्ञापन जोड़ें',
    reachUsers: 'हजारों उपयोगकर्ताओं तक पहुंचें',
    selectPackage: 'पैकेज चुनें',
    adDetails: 'विज्ञापन विवरण',
    advertiserName: 'विज्ञापनदाता का नाम',
    adTitle: 'विज्ञापन शीर्षक',
    adDescription: 'विज्ञापन विवरण',
    videoUrl: 'वीडियो URL',
    thumbnailUrl: 'थंबनेल URL',
    totalAmount: 'कुल राशि',
    continueToPayment: 'भुगतान जारी रखें',
    selectPaymentMethod: 'भुगतान विधि चुनें',
    amountRequired: 'आवश्यक राशि',
    payNow: 'अभी भुगतान करें',
    paymentSuccess: 'भुगतान सफल!',
    paymentSuccessMsg: 'आपके विज्ञापन की समीक्षा होगी और जल्द सक्रिय होगा',
    paymentCancelled: 'भुगतान रद्द',
    paymentCancelledMsg: 'भुगतान रद्द कर दिया गया',
    retry: 'पुनः प्रयास करें',
    backToHome: 'होम पर वापस',
    success: 'सफल!',
    error: 'त्रुटि',
    fillAllFields: 'कृपया सभी आवश्यक फ़ील्ड भरें',
    back: 'वापस',
    cancel: 'रद्द करें',
    confirm: 'पुष्टि करें',
    save: 'सेव करें',
    delete: 'हटाएं',
    edit: 'संपादित करें',
    send: 'भेजें',
    close: 'बंद करें',
    points: 'पॉइंट्स',
    today: 'आज',
    available: 'उपलब्ध',
    remaining: 'शेष',
    earnRate: 'कमाई दर',
    totalPoints: 'कुल पॉइंट्स',
    currentBalance: 'वर्तमान बैलेंस',
  },
};

export default translations;
